import React from 'react';
import { useTranslation } from 'react-i18next';

interface PowerOutageScheduleLimitApplyButton {
  testId?: string;
  className?: string;
  onClick?: () => void;
  isDisabled?: boolean;
}

export const PowerOutageScheduleLimitApplyButton: React.FC<
  PowerOutageScheduleLimitApplyButton
> = ({ testId, className, onClick, isDisabled }) => {
  const { t } = useTranslation();
  const disabledClassName = isDisabled ? '[&]:bg-dark-4 [&]:text-light-10' : '';

  return (
    <div
      className={`noto-medium-3 flex h-[30px] w-[60px] cursor-pointer items-center justify-center rounded-[5px] bg-dark-4 leading-[23px] text-white shadow-6 hover:bg-dark-3 ${disabledClassName} ${className}`}
      data-testid={testId}
      onClick={onClick}
    >
      {t('overview.modal.limit.button')}
    </div>
  );
};
